function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicesModern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "services_modern") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    d: "m10 13 1.145-2.583 2.537-1.167-2.537-1.167L10 5.5 8.855 8.083 6.318 9.25l2.536 1.167zm-6.545 2.5a1.561 1.561 0 0 1-1.155-.489 1.621 1.621 0 0 1-.481-1.177V4.667A1.621 1.621 0 0 1 2.3 3.489 1.561 1.561 0 0 1 3.455 3h13.09a1.563 1.563 0 0 1 1.156.489 1.622 1.622 0 0 1 .48 1.178v9.167a1.622 1.622 0 0 1-.48 1.177 1.563 1.563 0 0 1-1.156.489zM1.818 18a.782.782 0 0 1-.583-.24.865.865 0 0 1 0-1.187.782.782 0 0 1 .583-.24h16.364a.782.782 0 0 1 .583.24.865.865 0 0 1 0 1.187.782.782 0 0 1-.583.24z",
    transform: "translate(2 2)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesModern);
export default __webpack_public_path__ + "static/media/services_modern.c996ee7e933d8a14945cbce3d165e56d.svg";
export { ForwardRef as ReactComponent };